// @flow
import LegacyComparisonGridDiamondItem from '@components/diamond_comparison/LegacyComparisonGridDiamondItem';

import type { DiamondType } from '@types/diamond';

type PropsType = {
  diamonds: Array<DiamondType>,
  onRemoveClick: (ID: string) => void
};

const LegacyComparisonGridDiamonds = ({
  diamonds,
  onRemoveClick
}: PropsType) => {
  return (
    <div id='compareRightTableContainer'>
      <table id='compareRightTable' className='compare-table'>
        <tbody>
          <tr>
            {diamonds.map(diamond => (
              <LegacyComparisonGridDiamondItem
                diamond={diamond}
                onRemoveClick={onRemoveClick}
                key={diamond.list_service_diamond_id}
              />
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default LegacyComparisonGridDiamonds;
